import ReactGA4 from "react-ga4";
import { shopId } from "src/config";

export const sendGACouponEvent = (lineId, couponId, ga) => {
  if (!lineId || !ga || !couponId) return;

  ReactGA4.set({
    page: `shop/${shopId}/user/${lineId}`,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    title: ga,
    userId: `shop/${shopId}/user/${lineId}`,
  });
  const event = {
    category: `coupon/${shopId}`,
    action: `exchange/customer/${lineId}/coupon/${couponId}`,
    label: `shop/${shopId}/customer/${lineId}/coupon/${couponId}`,
    value: 1,
  };
  ReactGA4.event({ ...event, shopId, lineId });
};

export const sendGAFormEvent = (lineId, action) => {
  if (!lineId || !action) return;

  ReactGA4.set({
    page: `shop/${shopId}/user/${lineId}`,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    title: "/form",
    userId: `shop/${shopId}/user/${lineId}`,
  });
  const event = {
    category: `coupon/${shopId}`,
    action: `${action}/customer/${lineId}`,
    label: `shop/${shopId}/customer/${lineId}`,
    value: 1,
  };
  ReactGA4.event({ ...event, shopId, lineId });
};

export const sendGaView = (lineId, ga) => {
  if (!lineId || !ga) return;
  const page = `/shop/${shopId}/user/${lineId}/action/${ga}`;
  ReactGA4.set({
    page: `shop/${shopId}/user/${lineId}`,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    title: ga,
    userId: `shop/${shopId}/user/${lineId}`,
  });
  ReactGA4.send({ hitType: "pageview", page, title: ga });
};
